export default {
    baseStyle: {
        wrapper: {
            background: 'white',
            flex: 1,
            padding: '45px 0 80px 0'
        },
        flex: {
            direction: {
                base: 'column',
                lg: 'row'
            },
            gap: '50px'
        },
        column: {
            flex: {
                base: '1',
                lg: '2'
            },
            stack: {
                spacing: '4'
            },
            review: {
                pt: 3,
                display: {
                    base: 'none',
                    lg: 'block'
                }
            }
        },
        summary: {
            flex: '1',
            display: {
                base: 'none',
                md: 'block'
            },
            review: {
                display: {
                    base: 'none',
                    lg: 'block'
                },
                pt: 2
            }
        },
        review: {
            display: {
                lg: 'none'
            },
            position: 'sticky',
            bottom: 0,
            px: 4,
            pt: 6,
            pb: 11,
            background: 'white',
            borderTop: '1px solid',
            borderColor: 'gray.100'
        },
        promocodetext: {
            padding: '1rem'
        }
    }
}
